export const FEEDBACK_TOOLTIPS: Record<
  string,
  {
    key: string
    reworkTooltipText: string
    submissionTooltipText: string
  }
> = {
  grammar: {
    key: 'grammar',
    reworkTooltipText:
      'Select the correct option(s) if the language and grammar in the copy needs improvement.',
    submissionTooltipText:
      'Select the correct option(s) if you felt the text did not read well or that the language could have been better.'
  },
  irrelevant: {
    key: 'irrelevant',
    reworkTooltipText:
      'Select the correct option(s) if the substance, research, and information need improvement.',
    submissionTooltipText:
      'Select the correct option(s) if you felt the substance, research, or information in the copy was inadequate, incorrect, or unoriginal.'
  },
  outline: {
    key: 'outline',
    reworkTooltipText:
      'Select the correct option(s) if the client’s instructions or the creative brief was ignored.',
    submissionTooltipText:
      'Select the correct option(s) if you felt the client’s instructions were ignored or the creative brief was not followed.'
  },
  initiative: {
    key: 'initiative',
    reworkTooltipText:
      'Please select this option if the creator’s comments were disrespectful or if feedback was not addressed.',
    submissionTooltipText:
      'Please select this option if the creator’s comments were disrespectful or if feedback was not addressed.'
  }
}
